import { render, staticRenderFns } from "./Question.vue?vue&type=template&id=0e31a038&scoped=true&"
import script from "@/scripts/QA/Question/index.js?vue&type=script&lang=js&"
export * from "@/scripts/QA/Question/index.js?vue&type=script&lang=js&"
import style0 from "./Question.vue?vue&type=style&index=0&id=0e31a038&scoped=true&lang=css&"
import style1 from "./Question.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e31a038",
  null
  
)

export default component.exports